import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import useFetch from 'core/hooks/use-fetch'

const Weather = props => {
  const locale = window.navigator.userLanguage || window.navigator.language
  const [time, setTime] = useState(
    new Date().toLocaleTimeString([locale], {
      hour: 'numeric',
      minute: 'numeric'
    })
  )
  const tick = () => {
    setTime(
      new Date().toLocaleTimeString([locale], {
        hour: 'numeric',
        minute: 'numeric'
      })
    )
  }
  useEffect(() => {
    setInterval(tick, 1000)
  })

  const { loading, error, data } = useFetch(`/weather/${props.query}`)

  if (loading) return 'Loading...'
  if (!data) return null
  if (error) {
    console.error('Error:', error.message)
  }

  let temp = ''
  const localize = unit => {
    temp = new Intl.NumberFormat(locale, { maximumFractionDigits: 1 }).format(unit)
  }

  // Convert temperature from Kelvin to something useful.
  if (locale === 'en-US' || locale === 'en_US') {
    const fahrenheit = data.main && parseFloat(data.main.temp * (9 / 5) - 459.67)
    localize(fahrenheit)
  } else {
    const celsius = data.main && parseFloat(data.main.temp - 273.15)
    localize(celsius)
  }

  return (
    <ul className="weather">
      <li>{time}</li>
      {data.name && data.name.length > 0 && <li>{data.name}</li>}
      {data.weather[0].description && data.weather[0].description.length > 0 && (
        <li>{data.weather[0].description}</li>
      )}
      {temp && temp.length > 0 && <li>{temp}</li>}
    </ul>
  )
}

Weather.propTypes = {
  query: PropTypes.string.isRequired
}
export default Weather
